import { useQuery } from '@tanstack/react-query'
import { useDebounce } from './useDebounce'
import { searchPlanograms } from '@/api/planograms'

export function usePlanogramSearch(query: string, debounceMs = 300) {
  const debouncedQuery = useDebounce(query, debounceMs)

  return useQuery({
    queryKey: ['planograms', 'search', debouncedQuery],
    queryFn: () =>
      searchPlanograms({
        search: debouncedQuery || undefined,
        include_inactive: false,
        limit: 50,
      }),
    staleTime: 1000 * 60,
  })
}
